module.exports = __webpack_public_path__ + "static/media/arrow-down.f2df1b59.svg";